// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1eqVf","large":"styles_large__AysDu"};